import { render, staticRenderFns } from "./GameCurrencies.vue?vue&type=template&id=1e45b4dd&scoped=true&lang=pug"
import script from "./GameCurrencies.vue?vue&type=script&lang=js"
export * from "./GameCurrencies.vue?vue&type=script&lang=js"
import style0 from "./GameCurrencies.vue?vue&type=style&index=0&id=1e45b4dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45b4dd",
  null
  
)

export default component.exports